import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CloseIcon from '@material-ui/icons/Close';
import LockIcon from '@material-ui/icons/Lock';
import RedesignModal from '../../../shared/components/RedesignModal';
import { useTestLimitModalStyles } from './TestLimitModal.styles';

export type TestLimitModalProps = {
  open: boolean;
  onClose: () => void;
  onUnlock: () => void;
};

const TestLimitModal = ({ open, onClose, onUnlock }: TestLimitModalProps) => {
  const classes = useTestLimitModalStyles();

  return (
    <RedesignModal
      open={open}
      onClose={onClose}
      labelledBy="test-limit-modal-title"
      paperClassName={classes.modal}>
      <IconButton className={classes.closeButton} onClick={onClose} aria-label="Fermer">
        <CloseIcon className={classes.closeIcon} />
      </IconButton>

      <span className={classes.iconWrap} aria-hidden="true">
        <LockIcon className={classes.lockIcon} />
      </span>

      <div className={classes.textBlock}>
        <h2 id="test-limit-modal-title" className={classes.title}>
          Information
        </h2>
        <p className={classes.message}>
          Vous avez atteint la limite de test offert par E-OrientAction
        </p>
      </div>

      <div className={classes.actions}>
        <Button
          className={classes.primaryButton}
          endIcon={<ArrowForwardIcon className={classes.primaryButtonIcon} />}
          onClick={onUnlock}
          fullWidth={true}>
          Débloquer
        </Button>
        <Button
          variant="outlined"
          className={classes.secondaryButton}
          onClick={onClose}
          fullWidth={true}>
          Non merci
        </Button>
      </div>
    </RedesignModal>
  );
};

export default TestLimitModal;
